'use strict';

import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/tooltip';
import 'select2';
import MapboxDraw from '@mapbox/mapbox-gl-draw';

const AColorPicker = require('a-color-picker');

import { point } from '@turf/helpers';
import circle from '@turf/circle';

import * as MapboxDrawGeodesic from './shapes/tools';
import { extendDrawBar } from './shapes/extendDrawBar.js';




/**
 * Init Shapes Logic
 */
class TWER_SHAPES {

  map = {};
  Draw = {};

  drawFeatureID = '';
  newDrawFeature = false;
  drawFeatureIDStyles = {};

  DEFAULT_STYLES = {};
  SETTINGS_FIELDS = {};



  constructor($) {
    window.$ = $;

    if (twer_ajax.api_key_is_valid) {

      this.DEFAULT_STYLES = {
        LineString: {
          line_color: '#438ee4',
          line_width: 2,
          line_dasharray: [1, 0],
          line_dash: 1,
          line_gap: 0,
        },
        Polygon: {
          fill_color: 'rgba(67,142,228,0.3)',
          stroke_color: '#438ee4',
          stroke_width: 2,
          stroke_dasharray: [1, 0],
          stroke_dash: 1,
          stroke_gap: 0
        },
        Circle: {
          fill_color: 'rgba(67,142,228,0.3)',
          stroke_color: '#438ee4',
          stroke_width: 2,
          stroke_dasharray: [1, 0],
          stroke_dash: 1,
          stroke_gap: 0
        }
      };

      this.SETTINGS_FIELDS = {
        LineString: ['line_color', 'line_width', 'line', 'line_dash', 'line_gap'],
        Polygon: ['fill_color', 'stroke_color', 'stroke_width', 'stroke', 'stroke_dash', 'stroke_gap'],
        Circle: ['fill_color', 'stroke_color', 'stroke_width', 'stroke', 'stroke_dash', 'stroke_gap']
      };

      TWER_MAPBOX.mapboxgl.accessToken = twer_ajax.api_key;

      const defaultStyles = this.get_default_styles();
      const defaultStylesLine = defaultStyles.LineString;
      const defaultStylesPolygon = defaultStyles.Polygon;


      let modes = MapboxDraw.modes;
      modes = MapboxDrawGeodesic.enable(modes);

      this.Draw = new MapboxDraw({
        modes,
        displayControlsDefault: false,
        userProperties: true,
        styles: [
          // Line style settings
          {
            'id': 'gl-draw-line',
            'type': 'line',
            'filter': [
              'all',
              ['==', '$type', 'LineString'],
              ['!=', 'mode', 'static'],
            ],
            'layout': {
              'line-cap': 'round',
              'line-join': 'round'
            },
            'paint': {
              'line-color': [
                'case',
                ['to-boolean', ['get', 'user_line_color']],
                ['to-color', ['get', 'user_line_color']],
                defaultStylesLine.line_color
              ],
              'line-dasharray': [
                'case',
                ['to-boolean', ['get', 'user_line_dasharray']],
                ['get', 'user_line_dasharray'],
                ['literal', defaultStylesLine.line_dasharray]
              ],
              'line-width': [
                'case',
                ['to-boolean', ['to-string', ['get', 'user_line_width']]],
                ['to-number', ['get', 'user_line_width']],
                defaultStylesLine.line_width
              ]
            }
          },

          // Polygon style settings
          {
            'id': 'gl-draw-polygon-fill-inactive',
            'type': 'fill',
            'filter': [
              'all',
              ['==', 'active', 'false'],
              ['==', '$type', 'Polygon'],
              ['!=', 'mode', 'static']
            ],
            'paint': {
              'fill-antialias' : false,
              'fill-color': [
                'case',
                ['to-boolean', ['get', 'user_fill_color']],
                ['to-color', ['get', 'user_fill_color']],
                defaultStylesPolygon.fill_color
              ],
            }
          },
          {
            'id': 'gl-draw-polygon-fill-active',
            'type': 'fill',
            'filter': ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
            'paint': {
              'fill-antialias' : false,
              'fill-color': [
                'case',
                ['to-boolean', ['get', 'user_fill_color']],
                ['to-color', ['get', 'user_fill_color']],
                defaultStylesPolygon.fill_color
              ],
            }
          },
          {
            'id': 'gl-draw-polygon-fill-static',
            'type': 'fill',
            'filter': ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],
            'paint': {
              'fill-antialias' : false,
              'fill-color': [
                'case',
                ['to-boolean', ['get', 'user_fill_color']],
                ['to-color', ['get', 'user_fill_color']],
                defaultStylesPolygon.fill_color
              ],
            }
          },

          {
            'id': 'gl-draw-polygon-stroke-inactive',
            'type': 'line',
            'filter': [
              'all',
              ['==', 'active', 'false'],
              ['==', '$type', 'Polygon'],
              ['!=', 'mode', 'static']
            ],
            'layout': {
              'line-cap': 'round',
              'line-join': 'round'
            },
            'paint': {
              'line-color': [
                'case',
                ['to-boolean', ['get', 'user_stroke_color']],
                ['to-color', ['get', 'user_stroke_color']],
                defaultStylesPolygon.stroke_color
              ],
              'line-dasharray': [
                'case',
                ['to-boolean', ['get', 'user_stroke_dasharray']],
                ['get', 'user_stroke_dasharray'],
                ['literal', defaultStylesPolygon.stroke_dasharray]
              ],
              'line-width': [
                'case',
                ['to-boolean', ['to-string', ['get', 'user_stroke_width']]],
                ['to-number', ['get', 'user_stroke_width']],
                defaultStylesPolygon.stroke_width
              ]
            }
          },
          {
            'id': 'gl-draw-polygon-stroke-active',
            'type': 'line',
            'filter': ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
            'layout': {
              'line-cap': 'round',
              'line-join': 'round'
            },
            'paint': {
              'line-color': [
                'case',
                ['to-boolean', ['get', 'user_stroke_color']],
                ['to-color', ['get', 'user_stroke_color']],
                defaultStylesPolygon.stroke_color
              ],
              'line-dasharray': [
                'case',
                ['to-boolean', ['get', 'user_stroke_dasharray']],
                ['get', 'user_stroke_dasharray'],
                ['literal', defaultStylesPolygon.stroke_dasharray]
              ],
              'line-width': [
                'case',
                ['to-boolean', ['to-string', ['get', 'user_stroke_width']]],
                ['to-number', ['get', 'user_stroke_width']],
                defaultStylesPolygon.stroke_width
              ]
            }
          },
          {
            'id': 'gl-draw-polygon-stroke-static',
            'type': 'line',
            'filter': ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],
            'layout': {
              'line-cap': 'round',
              'line-join': 'round'
            },
            'paint': {
              'line-color': [
                'case',
                ['to-boolean', ['get', 'user_stroke_color']],
                ['to-color', ['get', 'user_stroke_color']],
                defaultStylesPolygon.stroke_color
              ],
              'line-dasharray': [
                'case',
                ['to-boolean', ['get', 'user_stroke_dasharray']],
                ['get', 'user_stroke_dasharray'],
                ['literal', defaultStylesPolygon.stroke_dasharray]
              ],
              'line-width': [
                'case',
                ['to-boolean', ['to-string', ['get', 'user_stroke_width']]],
                ['to-number', ['get', 'user_stroke_width']],
                defaultStylesPolygon.stroke_width
              ]
            }
          },

          // Point style settings
          {
            'id': 'gl-draw-polygon-midpoint',
            'type': 'circle',
            'filter': [
              'all',
              ['==', '$type', 'Point'],
              ['==', 'meta', 'midpoint']],
            'paint': {
              'circle-radius': 0,
              'circle-color': '#fff'
            }
          },
          {
            'id': 'gl-draw-polygon-and-line-vertex-stroke-inactive',
            'type': 'circle',
            'filter': [
              'all',
              ['==', 'meta', 'vertex'],
              ['==', '$type', 'Point'],
              ['!=', 'mode', 'static']
            ],
            'paint': {
              'circle-radius': 10,
              'circle-color': '#fff'
            }
          },
          {
            'id': 'gl-draw-polygon-and-line-vertex-inactive',
            'type': 'circle',
            'filter': [
              'all',
              ['==', 'meta', 'vertex'],
              ['==', '$type', 'Point'],
              ['!=', 'mode', 'static']
            ],
            'paint': {
              'circle-radius': 5,
              'circle-color': '#438ee4'
            }
          },
          {
            'id': 'gl-draw-point-static',
            'type': 'circle',
            'filter': ['all', ['==', 'mode', 'static'], ['==', '$type', 'Point']],
            'paint': {
              'circle-radius': 5,
              'circle-color': '#438ee4'
            }
          },
          {
            'id': 'gl-draw-point-active',
            'type': 'circle',
            'filter': [
              'all',
              ['==', '$type', 'Point'],
              ['!=', 'meta', 'midpoint'],
              ['==', 'active', 'true']],
            'paint': {
              'circle-radius': 5,
              'circle-color': '#438ee4'
            }
          },
          {
            'id': 'gl-draw-point-inactive',
            'type': 'circle',
            'filter': [
              'all',
              ['==', 'active', 'false'],
              ['==', '$type', 'Point'],
              ['==', 'meta', 'feature'],
              ['!=', 'mode', 'static']
            ],
            'paint': {
              'circle-radius': 3,
              'circle-color': '#438ee4'
            }
          },
          {
            'id': 'gl-draw-point-stroke-active',
            'type': 'circle',
            'filter': [
              'all',
              ['==', '$type', 'Point'],
              ['==', 'active', 'true'],
              ['!=', 'meta', 'midpoint']
            ],
            'paint': {
              'circle-radius': 5,
              'circle-color': '#438ee4'
            }
          },
          {
            'id': 'gl-draw-point-point-stroke-inactive',
            'type': 'circle',
            'filter': [
              'all',
              ['==', 'active', 'false'],
              ['==', '$type', 'Point'],
              ['==', 'meta', 'feature'],
              ['!=', 'mode', 'static']
            ],
            'paint': {
              'circle-radius': 5,
              'circle-opacity': 1,
              'circle-color': '#ac2929'
            }
          },
          {
            'id': 'gl-draw-polygon-and-line-midpoint-active',
            'type': 'circle',
            'filter': [
              'all',
              ['==', 'meta', 'midpoint'],
              ['==', '$type', 'Point'],
              ['!=', 'mode', 'static']
            ],
            'paint': {
              'circle-radius': 5,
              'circle-color': '#438ee4'
            }
          },
          {
            'id': 'gl-draw-polygon-and-line-vertex-active',
            'type': 'circle',
            'filter': [
              'all',
              ['==', 'meta', 'vertex'],
              ['==', '$type', 'Point'],
              ['!=', 'mode', 'static']
            ],
            'paint': {
              'circle-radius': 5,
              'circle-color': '#438ee4',
            }
          }
        ],
      });

      const $mapLngLatField = document.getElementById('map_lnglat');
      const $mapZoomField = document.getElementById('map_zoom');

      this.map = new TWER_MAPBOX.mapboxgl.Map({
        container: 'js-twer-map',
        style: twer_ajax.current_style_map,
        center: $mapLngLatField.value.trim() !== '' ? JSON.parse($mapLngLatField.value) : [-74.5, 40],
        zoom: $mapZoomField.value.trim() !== '' ? JSON.parse($mapZoomField.value) : 9,
      });

      this.draw_bar_init();
      this.set_center_map();
      this.set_zoom_map();
      this.draw_load_features();

      this.map.on('render', (event) => {
        this.set_center_map();
        this.set_zoom_map();
      });
      this.map.on('draw.render', (event) => this.draw_render(event));
      this.map.on('draw.create', event => this.draw_create(event));
      this.map.on('draw.update', event => this.draw_update(event));
      this.map.on('draw.delete', event => this.draw_delete(event));
      this.map.on('draw.selectionchange', event => this.draw_change(event));
      this.map.on('click', event => this.map_click(event));
    }

    this.init_map_multiselect();
    this.init_colorpicker();
    //this.init_vanilla_colorpicker();
    this.fields_watch();
  }

  toggle_message(show = true) {
    const $msg = document.getElementById('js-twer-map-msg');

    if(show) {
      $msg.classList.add('active');
    } else {
      $msg.classList.remove('active');
    }
  }

  draw_bar_init() {
    const drawBezierLine = {
      on: 'click', action: (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.toggle_message();
        this.Draw.changeMode('draw_bezier_curve');
      }, classes: ['mapbox-gl-draw_bezier_curve'], title: 'Bezier Tool'
    };
    const drawLineString = {
      on: 'click', action: (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.toggle_message(false);
        this.Draw.changeMode('draw_line_string');
      }, classes: ['mapbox-gl-draw_line'], title: 'LineString Tool'
    };

    const drawPolygon = {
      on: 'click', action: (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggle_message(false);
        this.Draw.changeMode('draw_polygon');

      }, classes: ['mapbox-gl-draw_polygon'], title: 'Polygon Tool'
    };
    const drawCircleBtn = {
      on: 'click', action: (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggle_message(false);
        this.Draw.changeMode('draw_circle');
      }, classes: ['mapbox-gl-draw_circle'], title: 'Circle Tool'
    };
    const trashBtn = {
      on: 'click', action: (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggle_message(false);
        this.Draw.trash();
      }, classes: ['mapbox-gl-draw_trash'], title: 'Delete'
    };

    //const drawPointBtn =    {on: "click", action: () => {this.Draw.changeMode("draw_point")}, classes: ["mapbox-gl-draw_point"], title:'Marker tool'};
    //const combineBtn =      {on: "click", action: () => {this.Draw.combineFeatures()}, classes: ["mapbox-gl-draw_combine"], title:'Combine'};
    //const unCombineBtn =    {on: "click", action: () => {this.Draw.uncombineFeatures()}, classes: ["mapbox-gl-draw_uncombine"], title:'Uncombine'};

    let drawBar = new extendDrawBar({
      draw: this.Draw,
      buttons: [
        drawLineString,
        drawPolygon,
        drawCircleBtn,
        //drawPointBtn,
        drawBezierLine,
        trashBtn,
        //combineBtn,
        //unCombineBtn
      ],
    });
    this.map.addControl(drawBar, 'top-right');

    // Fix to allow deletion with Del Key when default trash icon is not shown. See https://github.com/mapbox/mapbox-gl-draw/issues/989
    this.Draw.options.controls.trash = true;
  }

  map_click(event) {
    if (!this.newDrawFeature) {
      let drawFeatureAtPoint = this.Draw.getFeatureIdsAt(event.point);

      //if another drawFeature is not found - reset drawFeatureID
      this.drawFeatureID = drawFeatureAtPoint.length ? drawFeatureAtPoint[0] : '';
    }

    this.newDrawFeature = false;

    //console.log('click', this.drawFeatureID);
  }

  set_zoom_map() {
    const zoom = this.map.getZoom();
    const $mapZoomField = document.getElementById('map_zoom');
    $mapZoomField.value = JSON.stringify(zoom);
  }

  set_center_map() {
    const {lng, lat} = this.map.getCenter();
    const $mapLngLatField = document.getElementById('map_lnglat');
    $mapLngLatField.value = JSON.stringify([lng, lat]);
  }

  get_settings_fields(shape = 'all') {
    let fields = this.SETTINGS_FIELDS;
    if (shape === 'all') {
      let list_fields = [];
      for (const key in fields) {
        list_fields = [...list_fields, ...fields[key]];
      }
      fields = list_fields;
    } else {
      fields = fields[shape];
    }
    return [...new Set(fields)];
  }

  toggle_settings(ids, event = 'hide_all') {
    const fields = this.get_settings_fields();
    if ('hide_all' === event) {
      //console.log(fields);
      for (let i = 0; i < fields.length; i++) {
        //console.log(fields[i]);
        document.querySelector(`[data-row-id="message"]`).classList.remove('d-none');
        document.querySelector(`[data-row-id="${fields[i]}"]`)?.classList.add('d-none');
      }
    } else {
      for (let i = 0; i < ids.length; i++) {
        if (event === 'show') {
          document.querySelector(`[data-row-id="message"]`).classList.add('d-none');
          document.querySelector(`[data-row-id="${ids[i]}"]`)?.classList.remove('d-none');
        } else if (event === 'hide') {
          document.querySelector(`[data-row-id="message"]`).classList.remove('d-none');
          document.querySelector(`[data-row-id="${ids[i]}"]`)?.classList.add('d-none');
        }
      }
    }
  }

  isObjectEmpty(obj) {
    return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
  }

  get_current_feature_id(featureId = '') {
    return featureId ? featureId : this.drawFeatureID;
  }

  get_shape_type(featureId) {
    let id = this.get_current_feature_id();
    if (featureId) {
      id = featureId;
    }
    const styles = this.get_feature_styles(id);
    return styles.type;
  }

  fields_watch() {
    const fields = this.get_settings_fields();
    //console.log(fields);
    for (let i = 0; i < fields.length; i++) {
      const idField = fields[i];

      const checkFieldExist = !!document.getElementById(idField);
      if (checkFieldExist) {
        const $field = document.getElementById(idField);

        $field.addEventListener('keyup', (event) => {
          const featureId = this.get_current_feature_id();
          const shape = this.get_shape_type();
          const defaultStyles = this.get_default_styles(shape);
          const id = event.target.id;

          //console.log('GET ELEMENT ID', id);

          const defaultValue = defaultStyles[id];
          const currentValue = event.target.value;

          //console.log('DEF / CUR', defaultValue, currentValue);
          let value = parseInt(this.fill_empty_field(currentValue, defaultValue));

          if (id.includes('dash') || id.includes('gap')) {
            const prefix_id = id.split('_')[0];
            let gap, dash;

            if (id.includes('dash')) {
              gap = parseInt(this.get_style_from_field(`${prefix_id}_gap`, defaultStyles[`${prefix_id}_gap`]));
              dash = value;
            }
            if (id.includes('gap')) {
              dash = parseInt(this.get_style_from_field(`${prefix_id}_dash`, defaultStyles[`${prefix_id}_dash`]));
              gap = value;
            }

            const merged_id_dasharray = `${prefix_id}_dasharray`;
            const merged_dasharray_value = [dash, gap];

            //console.log('FEATURE ID / ID / VALUE /', featureId, id, value, merged_id_dasharray, merged_dasharray_value);
            this.set_feature_styles(featureId, id, value);
            this.set_feature_styles(featureId, merged_id_dasharray, merged_dasharray_value);
            this.draw_apply_styles(merged_id_dasharray, merged_dasharray_value);
          } else {
            //console.log('FEATURE ID / ID / VALUE/ ', featureId, id, value);
            this.set_feature_styles(featureId, id, value);
            this.draw_apply_styles(id, value);
          }

          this.update_shape_styles_field();
        });
      }
    }
  }

  draw_load_features() {
    const $shapeStyles = document.getElementById('shape_styles');
    if ($shapeStyles.value.trim() !== '') {
      const styles = JSON.parse($shapeStyles.value);
      const features = styles.features;
      for (let i = 0; i < features.length; i++) {
        const featureId = features[i].id;
        const styles = features[i].properties;
        let shape = features[i].geometry.type;
        if (features[i].properties.hasOwnProperty('circleRadius')) {
          shape = 'Circle';
        }
        this.set_feature_styles(featureId, {...styles, ...{type: shape}});
      }
      this.Draw.set(styles);
    }
  }

  draw_render() {
    const allFeatures = this.Draw.getAll().features;

    if (allFeatures.length > 0) {
      for (let i = 0; i < allFeatures.length; i++) {
        const feature = allFeatures[i];
        let shape = feature.geometry.type;
        if (feature.properties.hasOwnProperty('circleRadius')) {
          shape = 'Circle';
        }
        const featureId = feature.id;
        const featureStyles = this.get_feature_styles();

        if (!featureStyles.hasOwnProperty(featureId)) {
          const defaultStyles = this.get_default_styles(shape);
          const fields = this.get_settings_fields(shape);

          this.set_feature_styles(featureId, {...defaultStyles, ...{type: shape}});

          this.toggle_settings('hide_all');
          this.toggle_settings(fields, 'show');
          this.reset_fields_styles(shape);

          //console.log('init dasharray END', this.drawFeatureIDStyles, this.DEFAULT_STYLES);
        }
      }
    }

    //console.log('render', this.drawFeatureIDStyles, this.DEFAULT_STYLES);
  }

  set_feature_styles(featureId, style, value = '') {
    if (value === '') {
      this.drawFeatureIDStyles[featureId] = style;
    } else {
      this.drawFeatureIDStyles[featureId][style] = value;
    }

    //console.log(style, value, this.drawFeatureIDStyles);
  }

  delete_feature_styles(featureId) {
    delete this.drawFeatureIDStyles[featureId];
  }

  get_feature_styles(featureId) {
    let styles = this.drawFeatureIDStyles;
    if (featureId) {
      styles = styles[featureId];
    }
    return styles;
  }

  get_default_styles(shape) {
    let styles = this.DEFAULT_STYLES;
    if (shape) {
      styles = styles[shape];
    }
    return styles;
  }

  draw_apply_styles(id, value, featureId = '') {
    featureId = featureId === '' ? this.get_current_feature_id() : featureId;
    this.Draw.setFeatureProperty(featureId, id, value);
    const feat = this.Draw.get(featureId);
    this.Draw.add(feat);
  }

  draw_create(event) {
    this.newDrawFeature = true;

    const drawStyles = {};
    let drawType = event.features[0].geometry.type;
    if (event.features[0].properties.hasOwnProperty('circleRadius')) {
      drawType = 'Circle';
    }
    const defaultStyles = this.get_default_styles();
    const featureId = this.get_current_feature_id(event.features[0].id);

    switch (drawType) {
      case 'LineString' :
        drawStyles.type = drawType;
        drawStyles.line_color = this.get_style_from_field('line_color', defaultStyles[drawType].line_color);
        drawStyles.line_width = parseInt(this.get_style_from_field('line_width', defaultStyles[drawType].line_width));
        drawStyles.line_dash = parseInt(this.get_style_from_field('line_dash', defaultStyles[drawType].line_dash));
        drawStyles.line_gap = parseInt(this.get_style_from_field('line_gap', defaultStyles[drawType].line_gap));
        drawStyles.line_dasharray = [drawStyles.line_dash, drawStyles.line_gap];
        break;
      case 'Polygon' :
      case 'Circle' :
        drawStyles.type = drawType;
        drawStyles.fill_color = this.get_style_from_field('fill_color', defaultStyles[drawType].fill_color);
        drawStyles.stroke_color = this.get_style_from_field('stroke_color', defaultStyles[drawType].stroke_color);
        drawStyles.stroke_width = parseInt(this.get_style_from_field('stroke_width', defaultStyles[drawType].stroke_width));
        drawStyles.stroke_dash = parseInt(this.get_style_from_field('stroke_dash', defaultStyles[drawType].stroke_dash));
        drawStyles.stroke_gap = parseInt(this.get_style_from_field('stroke_gap', defaultStyles[drawType].stroke_gap));
        drawStyles.stroke_dasharray = [drawStyles.stroke_dash, drawStyles.stroke_gap];
        break;
    }

    this.set_feature_styles(featureId, drawStyles);
    this.update_shape_styles_field();
    //console.log('create', event, this, this.drawFeatureIDStyles,);
  }

  fill_empty_field(value, default_value) {
    if (value.trim() === '') {
      value = default_value;
    }
    return value;
  }

  get_style_from_field(id, default_value) {
    return this.fill_empty_field(document.getElementById(id).value, default_value);
  }

  update_shape_styles_field(updateProps) {
    const $shapeStyles = document.getElementById('shape_styles');
    const features = this.get_feature_styles();

    for (const featureId in features) {
      const feature = features[featureId];
      for (const styleId in feature) {
        if (styleId === 'type' || styleId === 'circleRadius' || styleId === 'bezierGroup') continue;
        let styleValue = feature[styleId];

        if (styleId === 'circleRadius' && updateProps) {
          //styleValue = updateProps.features[0].properties.circleRadius;
        }
        //console.log(styleId, styleValue, featureId);
        this.draw_apply_styles(styleId, styleValue, featureId);
      }
    }


    const drawData = this.prepare_shape_styles_field(this.Draw.getAll());
    $shapeStyles.value = JSON.stringify(drawData);
  }

  prepare_shape_styles_field(drawData) {
    if (drawData.features.length > 0) {
      for (let i = 0; i < drawData.features.length; i++) {
        const feature = drawData.features[i];

        if (feature.properties.hasOwnProperty('circleRadius')) {
          const center = point(feature.geometry.coordinates[0][0]);
          const radius = feature.properties.circleRadius;
          const circleShape = circle(center, radius);
          drawData.features[i].geometry.coordinatesCircle = circleShape.geometry.coordinates;
        }
      }
    }
    return drawData;
  }

  draw_update(event) {
    if (event.features.length && event.features[0].type === 'Feature') {
      let feat = event.features[0];
      this.drawFeatureID = feat.id;
    }

    this.update_shape_styles_field(event);
  }

  draw_delete(event) {
    const featureId = this.get_current_feature_id();
    const shape = this.get_shape_type(featureId);
    const fields = this.get_settings_fields(shape);

    //this.toggle_settings(fields, 'hide');
    this.toggle_settings('hide_all');
    this.reset_fields_styles(shape);
    this.delete_feature_styles(featureId);
    this.update_shape_styles_field();
  }

  draw_get_shape_type_selected(event) {
    let shapeType = 'None';

    if(event && event.features.length > 0) {
      const properties = event.features[0].properties;
      const type = event.features[0].geometry.type;

      if(properties.hasOwnProperty('circleRadius')) {
        shapeType = 'Circle';
      } else if(properties.hasOwnProperty('bezierGroup')) {
        shapeType = 'BezierCurve';
      } else {
        shapeType = type;
      }
    }

    return shapeType;
  }
  draw_change(event) {
    if (event.features.length && event.features[0].type === 'Feature') {
      let feat = event.features[0];
      this.drawFeatureID = feat.id;
    }

    const featureId = this.get_current_feature_id();

    if('BezierCurve' === this.draw_get_shape_type_selected(event)) {
      this.toggle_message();
    } else {
      this.toggle_message(false);
    }
    if (featureId === '') {
      this.toggle_settings('hide_all');
    } else {
      const styles = this.get_feature_styles(featureId);
      const shape = this.get_shape_type(featureId);
      const fields = this.get_settings_fields(shape);

      //console.log('CHANGE', styles, shape, fields);

      this.toggle_settings('hide_all');
      this.toggle_settings(fields, 'show');
      this.reset_fields_styles(shape);
      this.apply_fields_styles();
    }


    //console.log(this.drawFeatureID, this.drawFeatureIDStyles);
    //console.log('change', event, this);
  }

  reset_fields_styles(shape) {
    const fields = this.get_settings_fields(shape);
    const defaultStyles = this.get_default_styles(shape);
    for (let i = 0; i < fields.length; i++) {
      const checkFieldExist = !!document.getElementById(`${fields[i]}`);
      if (checkFieldExist) {
        const $field = document.getElementById(`${fields[i]}`);
        $field.value = '';
        if ($field.className.includes('color') && fields[i].includes('color')) {
          $field.value = defaultStyles[fields[i]];
          $field.closest('.js-twer-colorpicker').querySelector('.js-twer-colorpicker-cell').style.backgroundColor = defaultStyles[fields[i]];
          $field.closest('.js-twer-colorpicker').querySelector('.js-twer-colorpicker-palette').setAttribute('acp-color', defaultStyles[fields[i]]);
        }
      }
    }
  }

  apply_fields_styles() {
    const featureId = this.get_current_feature_id();
    const currentStyles = this.get_feature_styles(featureId);
    const shape = this.get_shape_type(featureId);
    const fields = this.get_settings_fields(shape);
    const defaultStyles = this.get_default_styles(shape);

    for (let i = 0; i < fields.length; i++) {
      const checkFieldExist = !!document.getElementById(`${fields[i]}`);
      if (checkFieldExist) {
        const $field = document.getElementById(`${fields[i]}`);
        //console.log('APPLY FIELDS START', currentStyles[fields[i]], defaultStyles[fields[i]], $field);
        if (currentStyles[fields[i]] !== defaultStyles[fields[i]]) {
          $field.value = currentStyles[fields[i]];

          if ($field.className.includes('color') && fields[i].includes('color')) {
            $field.closest('.js-twer-colorpicker').querySelector('.js-twer-colorpicker-cell').style.backgroundColor = currentStyles[fields[i]];
            $field.closest('.js-twer-colorpicker').querySelector('.js-twer-colorpicker-palette').setAttribute('acp-color', currentStyles[fields[i]]);
          }
        } else {
          //console.log('FIELDS VALUES', $field.value);
        }
      }
    }
    //console.log('APPLY FIELDS', currentStyles, fields, defaultStyles);
  }

  init_vanilla_colorpicker() {
    const $colorPickers = document.getElementsByClassName('js-twer-colorpicker');
    const $colorPickerBtn = document.getElementsByClassName('js-twer-color-picker-btn');

    if ($colorPickers.length > 0) {
      for (let i = 0; i < $colorPickers.length; i++) {
        const $colorPicker = $colorPickers[i];
        const $colorInput = $colorPicker.getElementsByClassName('js-twer-colorpicker-color')[0];
        const currentColor = $colorInput.value;
        const $palette = $colorPicker.getElementsByClassName('js-twer-colorpicker-palette')[0];
        const $colorCell = $colorPicker.getElementsByClassName('js-twer-colorpicker-cell')[0];

        const picker = AColorPicker.from($palette, {
          showRGB: false,
          showHSL: false,
          paletteEditable: true,
          showAlpha: true,
          color: currentColor
        }).on('change', (picker, color) => {
          const colorInputId = $colorInput.id;
          const changedColor = picker.color;
          const rgba = picker.rgba;
          const rgbaOpacity = parseFloat(rgba[rgba.length - 1]);

          $colorCell.style.backgroundColor = changedColor;
          $colorInput.value = changedColor;
          $palette.setAttribute('acp-color', changedColor);

          $palette.querySelector('.js-twer-colorpicker-opacity').value = rgbaOpacity;

          const featureId = this.get_current_feature_id();
          if (featureId !== '' && !this.isObjectEmpty(this.drawFeatureIDStyles)) {
            this.set_feature_styles(featureId, colorInputId, changedColor);
            this.draw_apply_styles(colorInputId, changedColor);
            this.update_shape_styles_field();
          }

        }).on('coloradd', (picker, color) => {
          const $colorInputCustom = document.getElementsByClassName('js-twer-colorpicker-custom-color')[0];
          const customColor = $colorInputCustom.value;
          const addedColor = picker.color;

          if (customColor.indexOf('|' + addedColor) === -1) {
            $colorInputCustom.value = ($colorInputCustom.value + '|' + addedColor);

            $.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: $colorInputCustom.value},
              success: function(response) {
                let defaultCP = $palette.getAttribute('data-default-palette');
                $palette.setAttribute('acp-palette', defaultCP + '' + response);
                //$palette.setAttribute('acp-palette', defaultCP + '' + response);
                //colorPicker.attr('acp-palette', defaultCP + '' + response);
              }
            });
          }
        }).on('colorremove', (picker, color) => {
          const $colorInputCustom = document.getElementsByClassName('js-twer-colorpicker-custom-color')[0];
          const customColor = $colorInputCustom.value;
          const removedColor = picker.color;

          if (customColor.indexOf('|' + removedColor) !== -1) {
            $colorInputCustom.value = $colorInputCustom.value.replace('|' + removedColor, '');

            $.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: $colorInputCustom.value},
              success: function(response) {
                let defaultCP = $palette.getAttribute('data-default-palette');
                $palette.setAttribute('acp-palette', defaultCP + '' + response);
              }
            });
          }
        });

        const rgbaStatic = picker[0].rgba;
        const rgbaStaticOpacity = rgbaStatic[rgbaStatic.length - 1];
        $palette.setAttribute('acp-color', picker[0].color);
        $palette.querySelector('.a-color-picker-rgbhex input').insertAdjacentHTML('afterend', `<input type="text" class="twer-colorpicker-opacity js-twer-colorpicker-opacity" value="${rgbaStaticOpacity}" disabled>`);

        picker[0].hide();
        this.pickers[$colorInput.id] = picker;
      }
    }

    if ($colorPickerBtn.length > 0) {
      for (let j = 0; j < $colorPickerBtn.length; j++) {
        $colorPickerBtn[j].addEventListener('click', (event) => {
          event.preventDefault();

          const $colorPicker = event.target.closest('.js-twer-colorpicker');
          const $colorInput = $colorPicker.getElementsByClassName('js-twer-colorpicker-color')[0];
          this.pickers[$colorInput.id][0].toggle();
        });
      }
    }
  }

  init_colorpicker() {

    $(document).on('click', '.js-twer-colorpicker .btn', (event) => {
      event.preventDefault();
      const $colorPicker = $(event.target);
      const $colorPickerCell = $colorPicker.find('.js-twer-colorpicker-cell');
      const $colorPickerWrap = $colorPicker.closest('.js-twer-colorpicker');
      const $palette = $colorPickerWrap.find('.js-twer-colorpicker-palette');
      const $colorInput = $colorPickerWrap.find('.js-twer-colorpicker-color');
      const $colorDefaultInput = $colorPickerWrap.find('.js-twer-colorpicker-custom-color');
      let colorValue = $colorInput.val();
      if ($palette.find('.a-color-picker').length === 0) {
        AColorPicker.from($palette[0], {
          showRGB: false,
          showHSL: false,
          paletteEditable: true,
          showAlpha: true,
          //useAlphaInPalette : true,
          color: colorValue
        }).on('change', (picker, color) => {

          $(picker.element).closest('.js-twer-colorpicker').find('.js-twer-colorpicker-cell').css('background-color', picker.color);
          $colorInput.val(picker.color);
          $palette.attr('acp-color', picker.color);
          let colorValue1 = 1;
          if (picker.color.includes('rgba')) {
            colorValue1 = picker.color.split(',');
            colorValue1 = parseFloat(colorValue1[colorValue1.length - 1]);
          }
          $(picker.element).find('.js-twer-colorpicker-opacity').val(colorValue1);

          const featureId = this.get_current_feature_id();
          if (featureId !== '' && !this.isObjectEmpty(this.drawFeatureIDStyles)) {
            this.set_feature_styles(featureId, $colorInput.attr('id'), picker.color);
            this.draw_apply_styles($colorInput.attr('id'), picker.color);
            this.update_shape_styles_field();
          }

        }).on('coloradd', (picker, color) => {
          let cca = $colorDefaultInput;
          if (cca.val().indexOf('|' + picker.color) === -1) {
            cca.val(cca.val() + '|' + picker.color);
            $.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: cca.val()},
              success: function(response) {
                let defaultCP = $palette.attr('data-default-palette');
                $palette.attr('acp-palette', defaultCP + '' + response);
                $palette.attr('acp-palette', defaultCP + '' + response);
                //colorPicker.attr('acp-palette', defaultCP + '' + response);
              }
            });
          }
        }).on('colorremove', (picker, color) => {
          let ccr = $colorDefaultInput;
          if (ccr.val().indexOf('|' + picker.color) !== -1) {
            let sc = ccr.val().replace('|' + picker.color, '');
            ccr.val(sc);
            $.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: ccr.val()},
              success: function(response) {
                let defaultCP = $palette.attr('data-default-palette');
                $palette.attr('acp-palette', defaultCP + '' + response);
              }
            });
          }
        });

        if (colorValue.includes('rgba')) {
          colorValue = colorValue.split(',');
          colorValue = parseFloat(colorValue[colorValue.length - 1]);
        } else {
          colorValue = 1;
        }

        $('.a-color-picker-rgbhex').append('<input type="text" class="twer-colorpicker-opacity js-twer-colorpicker-opacity" value="' + colorValue + '" disabled>');

      } else {
        $palette.find('.a-color-picker').remove();
      }

    });

    $('.js-twer-colorpicker-palette').on('click', function(event) {
      event.stopPropagation();
    });

    $(document).on('click', function(event) {
      if (!$(event.target).closest('.js-twer-colorpicker').length > 0) {
        $('.js-twer-colorpicker-palette').find('.a-color-picker').remove();
      }
    });
  }

  init_map_multiselect() {
    let scope = this;
    let defaultMapStyle = '';
    $('.js-map-multiselect').select2({
      placeholder: 'No maps selected',
      width: '100%',
      minimumResultsForSearch: -1,
      dropdownParent: '#treweler-shapes-settings-root'
    }).on('select2:select.bsnselect', function(evt) {
      var element = evt.params.data.element;
      var $element = $(element);
      $element.detach();

      $(this).append($element);
      $(this).trigger('change');

      let styleV = $('#map_id option:selected').toArray().map((item) => {
        return twer_ajax.maps[item.value];
      });

      if (styleV.length <= 0) {
        styleV = ['mapbox://styles/mapbox/streets-v11'];
      }

      //console.log(styleV[0], styleV);
      defaultMapStyle = styleV[0];
      scope.map.setStyle(styleV[0]);
    }).on('change', function() {
      let styleV = $('#map_id option:selected').toArray().map((item) => {
        return twer_ajax.maps[item.value];
      });
      if (styleV.length <= 0) {
        styleV = ['mapbox://styles/mapbox/streets-v11'];
        scope.map.setStyle(styleV[0]);
      }

      if (styleV.length > 0 && !styleV.includes(defaultMapStyle)) {
        defaultMapStyle = styleV[0];
        //console.log(scope.map);
        scope.map.setStyle(defaultMapStyle);
      }

    });
  }
}

new TWER_SHAPES(jQuery);
